import { useEffect } from 'react';

const FontPreloader = () => {
  useEffect(() => {
    const preloadFonts = () => {
      const fontPaths = [
        '/Order-Regular.ttf',
        '/Chaos1-Regular.ttf',
        '/Chaos2-Regular.ttf',
      ];

      fontPaths.forEach((fontPath) => {
        const link = document.createElement('link');
        link.href = process.env.PUBLIC_URL + fontPath;
        link.rel = 'preload';
        link.as = 'font';
        link.type = 'font/ttf';
        link.crossOrigin = 'anonymous';

        document.head.appendChild(link);
      });
    };

    preloadFonts();
  }, []);

  return null;
};

export default FontPreloader;
